export const TaskConstants = {
  TIME_PATTERN: /^(\d+h)?( ?\d+m)?( ?\d+s)?$|^\d+$/,
  TIME_PATTERN_PARSER: {
    FULL: /(\d+[hms]? ?)+$/,
    SIMPLE: /^\d+$/,
  },
};
